// initial-state-actions
export const SET_INITIAL_SEARCH_PARAMS: 'SET_INITIAL_SEARCH_PARAMS' =
  'SET_INITIAL_SEARCH_PARAMS' as const;
export const SET_INITIAL_SEARCH_PARAM_DATES: 'SET_INITIAL_SEARCH_PARAM_DATES' =
  'SET_INITIAL_SEARCH_PARAM_DATES' as const;

// date-select-actions
export const BLOCK_DATE_SELECTION: 'BLOCK_DATE_SELECTION' =
  'BLOCK_DATE_SELECTION' as const;
export const SELECT_DAY: 'SELECT_DAY' = 'SELECT_DAY' as const;
export const SELECT_DAY_FOR_HOTELS: 'SELECT_DAY_FOR_HOTELS' =
  'SELECT_DAY_FOR_HOTELS' as const;
export const SELECT_HOTEL_DAY: 'SELECT_HOTEL_DAY' = 'SELECT_HOTEL_DAY' as const;
export const SELECT_MONTH: 'SELECT_MONTH' = 'SELECT_MONTH' as const;
export const HOTEL_SELECT_MONTH: 'HOTEL_SELECT_MONTH' =
  'HOTEL_SELECT_MONTH' as const;

export const SELECT_WHOLE_YEAR: 'SELECT_WHOLE_YEAR' =
  'SELECT_WHOLE_YEAR' as const;

export const SET_IS_RETURN: 'SET_IS_RETURN' = 'SET_IS_RETURN' as const;
export const SET_HAS_HOTEL_DATA_ON_BOTH_DATES: 'SET_HAS_HOTEL_DATA_ON_BOTH_DATES' =
  'SET_HAS_HOTEL_DATA_ON_BOTH_DATES' as const;

// data-request-actions
export const REQUEST_MONTH_DATA: 'REQUEST_MONTH_DATA' =
  'REQUEST_MONTH_DATA' as const;
export const REQUEST_MONTH_DATA_BLOCKED: 'REQUEST_MONTH_DATA_BLOCKED' =
  'REQUEST_MONTH_DATA_BLOCKED' as const;
export const SET_PRICE_SOURCE_ID: 'SET_PRICE_SOURCE_ID' =
  'SET_PRICE_SOURCE_ID' as const;
export const CONFIRM_SELECTED_RESULT: 'CONFIRM_SELECTED_RESULT' =
  'CONFIRM_SELECTED_RESULT' as const;
export const REQUEST_INITIAL_DATA_ANALYSIS: 'REQUEST_INITIAL_DATA_ANALYSIS' =
  'REQUEST_INITIAL_DATA_ANALYSIS' as const;
export const REQUEST_DATA_ERROR_ANALYSIS: 'REQUEST_DATA_ERROR_ANALYSIS' =
  'REQUEST_DATA_ERROR_ANALYSIS' as const;
export const SET_BASE_REQUEST_PATH: 'SET_BASE_REQUEST_PATH' =
  'SET_BASE_REQUEST_PATH' as const;
export const REQUEST_HOTEL_DATE_PRICES_DATA: 'REQUEST_HOTEL_DATE_PRICES_DATA' =
  'REQUEST_HOTEL_DATE_PRICES_DATA' as const;
export const CONFIRM_SELECTED_HOTEL: 'CONFIRM_SELECTED_HOTEL' =
  'CONFIRM_SELECTED_HOTEL' as const;
export const MONTH_VIEW_PAGE_LOADED: 'MONTH_VIEW_PAGE_LOADED' =
  'MONTH_VIEW_PAGE_LOADED' as const;

// data-receive-actions
export const RECEIVE_DATA_ERROR: 'RECEIVE_DATA_ERROR' =
  'RECEIVE_DATA_ERROR' as const;
export const RECEIVE_MONTH_DATA: 'RECEIVE_MONTH_DATA' =
  'RECEIVE_MONTH_DATA' as const;
export const RECEIVE_MONTH_DATA_ANALYSIS: 'RECEIVE_MONTH_DATA_ANALYSIS' =
  'RECEIVE_MONTH_DATA_ANALYSIS' as const;
export const RECEIVE_PRICE_TRACES: 'RECEIVE_PRICE_TRACES' =
  'RECEIVE_PRICE_TRACES' as const;
export const RECEIVE_HOTEL_DATE_PRICES: 'RECEIVE_HOTEL_DATE_PRICES' =
  'RECEIVE_HOTEL_DATE_PRICES' as const;
export const RECEIVE_HOTEL_DATE_PRICES_EMPTY: 'RECEIVE_HOTEL_DATE_PRICES_EMPTY' =
  'RECEIVE_HOTEL_DATE_PRICES_EMPTY' as const;
export const RECEIVE_HOTEL_DATE_PRICES_ERROR: 'RECEIVE_HOTEL_DATE_PRICES_ERROR' =
  'RECEIVE_HOTEL_DATE_PRICES_ERROR' as const;

// filter-actions
export const SET_INITIAL_DIRECTNESS_FILTER: 'SET_INITIAL_DIRECTNESS_FILTER' =
  'SET_INITIAL_DIRECTNESS_FILTER' as const;
export const SET_DIRECTNESS_FILTER_ANALYSIS: 'SET_DIRECTNESS_FILTER_ANALYSIS' =
  'SET_DIRECTNESS_FILTER_ANALYSIS' as const;
export const SET_DIRECTNESS_FILTER_ENABLED: 'SET_DIRECTNESS_FILTER_ENABLED' =
  'SET_DIRECTNESS_FILTER_ENABLED' as const;
export const TRIGGER_SET_DIRECTNESS_FILTER: 'TRIGGER_SET_DIRECTNESS_FILTER' =
  'TRIGGER_SET_DIRECTNESS_FILTER' as const;

// departure-time-filter-actions
export const TOGGLE_DEPARTURE_TIME_FILTER: 'TOGGLE_DEPARTURE_TIME_FILTER' =
  'TOGGLE_DEPARTURE_TIME_FILTER' as const;
export const CLEAR_DEPARTURE_TIME_FILTER: 'CLEAR_DEPARTURE_TIME_FILTER' =
  'CLEAR_DEPARTURE_TIME_FILTER' as const;

// route-actions
export const SET_ROUTE: 'SET_ROUTE' = 'SET_ROUTE' as const;

// localisation-actions
export const SET_TRANSLATIONS: 'SET_TRANSLATIONS' = 'SET_TRANSLATIONS' as const;
export const SET_LOCALISATION_VARS: 'SET_LOCALISATION_VARS' =
  'SET_LOCALISATION_VARS' as const;
export const SET_FIRST_DAY_OF_WEEK: 'SET_FIRST_DAY_OF_WEEK' =
  'SET_FIRST_DAY_OF_WEEK' as const;

// view-mode-actions
export const SET_FLIGHT_VIEW_MODE: 'SET_FLIGHT_VIEW_MODE' =
  'SET_FLIGHT_VIEW_MODE' as const;
export const DISMISS_NO_DIRECTS_MESSAGE: 'DISMISS_NO_DIRECT_MESSAGE' =
  'DISMISS_NO_DIRECT_MESSAGE' as const;

// price-tracking-actions
export const SET_PROVIDER_DATA: 'SET_PROVIDER_DATA' =
  'SET_PROVIDER_DATA' as const;

// stay actions
export const SET_STAY: 'SET_STAY' = 'SET_STAY' as const;

// trip-duration-POC-actions
export const SET_TRIP_DURATION: 'SET_TRIP_DURATION' =
  'SET_TRIP_DURATION' as const;
export const CLEAR_TRIP_DURATION: 'CLEAR_TRIP_DURATION' =
  'CLEAR_TRIP_DURATION' as const;

// deal-hunter-actions
export const RADAR_SESSION_STARTED: 'RADAR_SESSION_STARTED' =
  'RADAR_SESSION_STARTED' as const;
export const RADAR_POLL_ATTEMPTED: 'RADAR_POLL_ATTEMPTED' =
  'RADAR_POLL_ATTEMPTED' as const;
export const RADAR_RESPONSE_RECEIVED: 'RADAR_RESPONSE_RECEIVED' =
  'RADAR_RESPONSE_RECEIVED' as const;
export const RADAR_POLL_COMPLETED: 'RADAR_POLL_COMPLETED' =
  'RADAR_POLL_COMPLETED' as const;
export const CLEAR_DEAL_HUNTER_SESSIONS: 'CLEAR_DEAL_HUNTER_SESSIONS' =
  'CLEAR_DEAL_HUNTER_SESSIONS' as const;

// michelin-recommendations-actions
export const MICHELIN_RECOMMENDATIONS_REQUESTED: 'MICHELIN_RECOMMENDATIONS_REQUESTED' =
  'MICHELIN_RECOMMENDATIONS_REQUESTED' as const;
export const MICHELIN_RECOMMENDATIONS_RECEIVED: 'MICHELIN_RECOMMENDATIONS_RECEIVED' =
  'MICHELIN_RECOMMENDATIONS_RECEIVED' as const;
export const MICHELIN_RECOMMENDATIONS_FAILED: 'MICHELIN_RECOMMENDATIONS_FAILED' =
  'MICHELIN_RECOMMENDATIONS_FAILED' as const;
export const MICHELIN_RECOMMENDATIONS_RESET: 'MICHELIN_RECOMMENDATIONS_RESET' =
  'MICHELIN_RECOMMENDATIONS_RESET' as const;

// hotel-content-actions
export const HOTEL_CONTENT_REQUESTED: 'HOTEL_CONTENT_REQUESTED' =
  'HOTEL_CONTENT_REQUESTED' as const;
export const HOTEL_CONTENT_RECEIVED: 'HOTEL_CONTENT_RECEIVED' =
  'HOTEL_CONTENT_RECEIVED' as const;
export const HOTEL_CONTENT_FAILED: 'HOTEL_CONTENT_FAILED' =
  'HOTEL_CONTENT_FAILED' as const;

// browse-actions
export const SET_VIEW_ID: 'SET_VIEW_ID' = 'SET_VIEW_ID' as const;
export const SET_JHA_TOKEN: 'SET_JHA_TOKEN' = 'SET_JHA_TOKEN' as const;
